import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { environment } from 'src/environments/environment';
import Cookies from 'js-cookie';

@Injectable({
  providedIn: 'root'
})
export class LogoutGuardService implements CanActivate {


  constructor(public authService: AuthService,
    private router: Router) { }

  canActivate(route: any, state: RouterStateSnapshot,) {
    let token = this.authService.getToken();
    let orgSelectId = this.authService.getId();
    // let sessionId = Cookies.get("sso_session");

    if (!token) {
      // SSO
      // const id = crypto.randomUUID();
      // window.location.href = 'http://localhost:5173/login?redirect_uri=http://localhost:4200/auth/callback&client_id=cb-sales&state=' + id;

      let id;
      const baseUrl = window.location.origin;

      // localStorage.removeItem('CSRF');
      // this.authService.removeToken();

      if (!localStorage.getItem('CSRF')) {
        id = crypto.randomUUID();
        localStorage.setItem('CSRF', id);
      }
      else {
        id = localStorage.getItem('CSRF');
      }
      console.log(state);

      if (!state.url.includes('/auth/callback')) {
        window.location.href = environment.ssoApiUrl + 'sso/authorize?client_id=cb-sales&redirect_uri=' + baseUrl + '/auth/callback&state=' + id + '&prompt=none';
      }


      if (!orgSelectId) {
        return true;
      }
      return true;
    }
    else {
      this.router.navigateByUrl('sales', { replaceUrl: true });
      return false;
    }
  }
}
